<template>
  <div class="row m-0">
    <div class="col-12 p-0">
      <div class="row m-0">
        <div class="col-12 mb-3 px-0 pb-3 border-bottom">
          <h4 class="mb-0">Help</h4>
        </div>
        <div class="col-12 p-0">
          <div class="row m-0">
            <div class="col-12 p-0 my-3" id="general">
              <h4>General</h4>
            </div>
            <div class="col-12">
              <h5 class="bold mb-2">About Remember Blue</h5>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  What is Remember Blue and for whom is it intended?
                </div>
                <div class="col-12">
                  Remember Blue is a free online service that allows you to be able to securely store valuable information and messages in the event something were to happen to you. As such, Remember Blue gives you the ability to better plan your legacy and is intended to be used for anyone who would like better control over their legacy.
                </div>
              </div>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  Remember Blue is currently in beta-testing phase. What does this mean?
                </div>
                <div class="col-12 mb-2">
                  Yes, Remember Blue is currently in a beta-testing phase and has been launched to a small group within South Africa. The intent of this phase is to help improve Remember Blue tailor our service offering to you.
                </div>
                <div class="col-12">
                  Currently Remember Blue is offering a limited range of services but this is intended to be expanded in time to help you better manage and plan your legacy.
                </div>
              </div>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  What is the purpose of Remember Blue and what can you do with it?
                </div>
                <div class="col-12">
                  Remember Blue is a platform that allows you to be remembered the way you want to be remembered. It gives you the ability to store and send messages, videos and/or photos to loved ones or trusted entities after you have passed on. These messages could be important information such as financial or insurance details, passwords for any digital services you use, your will and testament, as well as heartfelt messages.  These messages are secure with best-in-class security.
                </div>
              </div>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  What is the point of having an Remember Blue account?
                </div>
                <div class="col-12 mb-2">
                  A Remember Blue account can inspire you to get the most out of life and to digitally record significant moments so that you will not lose or forget them.
                </div>
                <div class="col-12">
                  This is not only valuable for yourself, but also for your loved ones after you have passed away. They can save the photos, messages and information that you left behind as a memorial. It also offers them guidance when making decisions about your funeral and (digital) legacy.
                </div>
              </div>
            </div>
            <div class="col-12">
              <h5 class="bold mb-2">Privacy and security</h5>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  Is my personal information secure with Remember Blue?**
                </div>
                <div class="col-12 mb-2">
                  Remember Blue knows top-of-the-line security is paramount when protecting sensitive information. We also recognize that in using our service, you are trusting us with the most important information and documents you own – and we don’t take that lightly.
                </div>
                <div class="col-12">
                  When you use the website, a secure connection is made using an SSL certificate. A secure SSL connection is recognisable by the https in the URL (web address bar) and an icon in the status bar of your browser. Remember Blue does everything in its power to ensure that this protection is up to date.
                </div>
              </div>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  What happens with any information I store on Remember Blue?**
                </div>
                <div class="col-12 mb-2">
                  Remember Blue does collect some of your information as detailed in our Privacy Policy for the purpose of improving our services and business offerings. We will never sell your personal information (including any of your details and contact information) to anyone.
                </div>
                <div class="col-12">
                  Any information provided to and processed by Remember Blue is done strictly in terms of the Protection of Personal Information Act (POPI).
                </div>
              </div>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  Will Remember Blue try to contact me?
                </div>
                <div class="col-12 mb-2">
                  Remember Blue will provide you with the option of receiving periodic communication intended on providing you with information that is pertinent to the services provided. You may unsubscribe from these communications at any time as detailed in our Privacy Policy.
                </div>
                <div class="col-12">
                  During our beta-testing phase, we will request feedback from you. Your feedback will assist us in improving the services we offer to you.
                </div>
              </div>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  What happens to my information if I do not log in for a while?
                </div>
                <div class="col-12">
                  Even if you do not log in regularly, your information will remain secure. It is important that your information is kept up to date to ensure that your wishes are fulfilled. Hence we will send you periodic email reminders if you have not logged into your account for a while. As outlined in our Privacy Policy, you may choose to unsubscribe from these reminders.
                </div>
              </div>
            </div>
            <div class="col-12">
              <h5 class="bold mb-2">Accessibility and contact</h5>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  How can I contact Remember Blue?
                </div>
                <div class="col-12">
                  The Remember Blue team can be contacted via email at enquiries@rememberblue.com.
                </div>
              </div>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  What should I do if there is a fault on the Remember Blue website?
                </div>
                <div class="col-12">
                  Remember Blue strives to avoid faults so that your information is always accessible. Should the website be out of use, then Remember Blue will do everything it can to ensure that the problem is solved as soon as possible. If you encounter problems when using the website or your account, just send an email to the Remember Blue team at enquiries@rememberblue.com and they will be able to assist you further.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 p-0">
          <div class="row m-0">
            <div class="col-12 p-0 my-3" id="registration">
              <h4>Registration</h4>
            </div>
            <div class="col-12">
              <h5 class="bold mb-2">Registration and logging in</h5>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  What is the difference between registering for and logging into Remember Blue?
                </div>
                <div class="col-12 mb-2">
                  You can both register for and log into Remember Blue from the Login/Register page at www.rememberblue.com
                </div>
                <div class="col-12 mb-2">
                  Registration is done only once and is free of charge. You only need to register if you do not already have a Remember Blue account.
                </div>
                <div class="col-12">
                  By logging into Remember Blue we mean entering your email address and password to get access to your account. This is only possible once you have registered for Remember Blue.
                </div>
              </div>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  How do I register with Remember Blue?
                </div>
                <div class="col-12 mb-2">
                  You can register with Remember Blue by using the registration box on the Login/Register page at www.rememberblue.com.
                </div>
                <div class="col-12">
                  An email will be sent to your provided email address. In order to activate your account, click on the link provided in the email. After your account is activated you will be able to login to your profile.
                </div>
              </div>
            </div>
            <div class="col-12">
              <h5 class="bold mb-2">Problems during registration</h5>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  I have not received a confirmation email to activate my account.
                </div>
                <div class="col-12 mb-2">
                  It is possible that the confirmation email has ended up in your junk mail or spam folder. Check if the email can be found there.
                </div>
                <div class="col-12">
                  If not, please send an email to enquiries@rememberblue.com and the Remember Blue team will be able to assist you further with completing your registration.
                </div>
              </div>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  I got a notification that the email address is already in use
                </div>
                <div class="col-12 mb-2">
                  This means that the email address has already been used to register an account. You can access the account with your email address and corresponding password by logging on the Login/Register page.
                </div>
                <div class="col-12">
                  If you have forgotten your password, you can change it by clicking on the link forgot password.
                </div>
              </div>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  What should I do when I cannot register?
                </div>
                <div class="col-12 mb-2">
                  If you are somehow unable to register for Remember Blue, please send an email to enquiries@rememberblue.com
                </div>
                <div class="col-12">
                  The Remember Blue team will assist you with your registration as soon as possible.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 p-0">
          <div class="row m-0">
            <div class="col-12 p-0 my-3" id="account">
              <h4>Account</h4>
            </div>
            <div class="col-12">
              <h5 class="bold mb-2">Email address and password</h5>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  What should I do if I have forgotten my password?**
                </div>
                <div class="col-12">
                  To create a new password, the forgot password link can be found on the the  Register/Login page. Click on the forgot password link. Enter the email address that is linked to your Remember Blue account. You will then receive an email with a link to reset your password.
                </div>
              </div>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  How can I change my current password?**
                </div>
                <div class="col-12 mb-2">
                  You can change your password when you are logged on. To do this, go to
                </div>
                <div class="col-12">
                  account> account settings>change password.
                </div>
              </div>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  How can I change my email address?**
                </div>
                <div class="col-12 mb-2">
                  You can change your email address when you are logged on. To do this, go to
                </div>
                <div class="col-12 mb-2">
                  account>account settings>change email address.
                </div>
                <div class="col-12">
                  After changing and saving your email address, you will receive a confirmation email to the new email account. From that moment on, this email address will be linked to your account.
                </div>
              </div>
            </div>
            <div class="col-12">
              <h5 class="bold mb-2">Account information</h5>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  How can I close or delete my account?**
                </div>
                <div class="col-12 mb-2">
                  You can do this by going to account> account settings> close account.
                </div>
              </div>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  If my account is closed, are my details retained?**
                </div>
                <div class="col-12 mb-2">
                  When you have confirmed the closure of your Remember Blue account in account>account settings, your account will be designated as Inactive. After 3 months, the account will be deleted, and all information permanently destroyed.
                </div>
                <div class="col-12">
                  One week before the end of the 3-month period, you will receive a reminder about the account deletion, and you will have an opportunity to re-activate your account.
                </div>
              </div>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  What happens to my account after I have passed on?
                </div>
                <div class="col-12 mb-2">
                  In the event that you have passed on, the trustees who are linked to your account will need to notify Remember Blue of your passing. Once Remember Blue has verified your passing, we will ensure that your messages are sent out to your loved ones.
                </div>
              </div>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  How long will my account remain active after I am deceased?**
                </div>
                <div class="col-12 mb-2">
                  Once your wishes and requests have been fulfilled your trustors will be notified that you cannot fulfil your trustee duties and your account will be closed. After 3 months, all information stored will be permanently destroyed.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 p-0">
          <div class="row m-0">
            <div class="col-12 p-0 my-3" id="trustees">
              <h4>Trustees</h4>
            </div>
            <div class="col-12">
              <h5 class="bold mb-2">General</h5>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  Why do you need trustees for Remember Blue?
                </div>
                <div class="col-12 mb-2">
                  A trustee is someone who you trust completely and who will be linked to your Remember Blue account so that they can notify Remember Blue when you pass away or are incapacitated.
                </div>
                <div class="col-12">
                  All messages you store on Remember Blue are delivered only after you have passed on and upon notification by a Trustee. Without a trustee, no one would be able to notify Remember Blue of your passing. This means that your final messages and requests will not be sent. Remember Blue recommends that you assign more than one trustee to your profile.
                </div>
              </div>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  Are my message recipients and trustees obliged to fulfil my requests and wishes?
                </div>
                <div class="col-12">
                  All requests and wishes that are recorded in Remember Blue does not impose a mandate or obligation to the message recipients, trustees or Remember Blue.  These are requests from you to your trustees and loved ones. It is assumed that your loved ones will consider it as a final tribute to you and fulfil your wishes.
                </div>
              </div>
            </div>
            <div class="col-12">
              <h5 class="bold mb-2">How does it work</h5>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  Where do I manage my trustees?
                </div>
                <div class="col-12 mb-2">
                  You can manage your trustees on the page homepage>Trustees.
                </div>
              </div>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  How can I link trustees to my account?
                </div>
                <div class="col-12 mb-2">
                  On the homepage you can click on 'Add Trustee' which will then take you to trustee management page where you can send people a request to become your trustee for Remember Blue. After you have sent someone a request, the page will display that person’s information, as well as the status of the request.
                </div>
                <div class="col-12 mb-2">
                  The person to whom you have sent an invitation will receive an e-mail with an explanation about Remember Blue and what is involved in being someone’s trustee. The person can then accept the request by clicking a link in the email.
                </div>
                <div class="col-12">
                  There can be an unlimited number of trustees linked to any one account. We do recommend more than two trustees but would caution you on adding potential bad actors to your trustee list.
                </div>
              </div>
            </div>
            <div class="col-12">
              <h5 class="bold mb-2">Security and decease</h5>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  Do my trustees know who the other trustees are?
                </div>
                <div class="col-12">
                  Remember Blue will not share your trustee list with anyone, even your trustees. Your trustees will not know who the other trustees are unless you choose to inform the people concerned yourself.
                </div>
              </div>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  Can a trustee gain access to my account?
                </div>
                <div class="col-12 mb-2">
                  A trustee does not have access to your account. A trustee may only initiate the verification process of your passing. When a Trustee initiates the verification process, you will automatically receive an email informing you of this action. You will be able to cancel the process by clicking a link in that email or by logging into your Remember Blue account.
                </div>
                <div class="col-12">
                  The cancellation must be done within five days of the initiation of the verification by the Trustee. Failure to cancel within this time period will result in your stored messages and requests being issued. .
                </div>
              </div>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  Can trustees change information in my account?
                </div>
                <div class="col-12">
                  No, this is not possible. Even after you have passed on, your trustees will not have access to your account.
                </div>
              </div>
            </div>
            <div class="col-12">
              <h5 class="bold mb-2">Being a trustee for others</h5>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  Can I also be a trustee for people?
                </div>
                <div class="col-12">
                  Yes, you can be a trusted person for multiple people and receive requests. When you become a trustee, it is expected of you to notify Remember Blue when your trustor has passed away. You can be a trustee for multiple people including individuals that are your trustees.
                </div>
              </div>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  Where do I manage the people for who I am a trustee?
                </div>
                <div class="col-12">
                  You can manage the people for who you are a trustee to on the homepage>Trustors page. When you accept a request, that person’s account information will be added to your overview of trustors. This is where you will find the information for all people that you are a trustee to.
                </div>
              </div>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  For how many people can I be a trustee myself?
                </div>
                <div class="col-12">
                  There is no maximum for the amount of people for whom you can be a trustee. You can be a trustee for multiple people and receive a request. You decide whether or not you accept the request.
                </div>
              </div>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  Will someone receive a notification if I deny a trustee request?
                </div>
                <div class="col-12">
                  There is a large degree of responsibility associated with being a trustee. If you choose to refuse to become someone’s trustee, he or she will not receive a confirmation via email. This will all them to plan for an alternative trustee.
                </div>
              </div>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  How do I indicate that I no longer want to be a trustee for someone?
                </div>
                <div class="col-12">
                  On the Homepage>Trustors page you can remove people for whom you no longer wish to be a trustee. If you click on that person’s information, a box will appear with a remove link. After you confirm your request, the link between both accounts will be removed and the person in question will be notified via email in order for them to plan for adding a new trustee.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 p-0">
          <div class="row m-0">
            <div class="col-12 p-0 my-3" id="messages">
              <h4>Messages</h4>
            </div>
            <div class="col-12">
              <h5 class="bold mb-2">How does it work</h5>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  What can I do with messages?
                </div>
                <div class="col-12 mb-2">
                  With messages you can compose and save heartfelt messages, digital and social media account management, event arrangements, policies and finance and legal documents which will be sent to your loved ones when you pass away. If it is important to you, we will be able to store it and deliver it after you pass on.
                </div>
                <div class="col-12">
                  We advise you to check your messages regularly to make sure they are still up to date.
                </div>
              </div>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  When will my messages be sent?
                </div>
                <div class="col-12">
                  Your messages are not sent until you have passed away. Confirmation of your passing requires the following: One of your trustees have notified Remember Blue that you have passed on and we at Remember Blue have been unsuccessful at contacting you using your provided contact details.
                </div>
              </div>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  How do I edit or delete an existing message?
                </div>
                <div class="col-12">
                  You can edit or delete any stored message by selecting the edit icon on any stored message. If you wish to delete the stored message you may select the delete function. Stored messages can be viewed on the homepage>messages page
                </div>
              </div>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  How do I change the category of a message?
                </div>
                <div class="col-12">
                  You can change the category of a message by clicking ‘select type of message’ in the homepage>messages page. This will provide a drop-down list of the types of messages that you can send.
                </div>
              </div>
            </div>
            <div class="col-12">
              <h5 class="bold mb-2">Security and privacy</h5>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  Can trustees read my personal messages?
                </div>
                <div class="col-12">
                  Trustees cannot read any of your messages. The only people that will see your messages are your intended recipients, and they are only provided with the message after your passing on has been confirmed. If you choose to send a personal message to a trustee, upon your passing they will receive that message.
                </div>
              </div>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  What will someone see if I leave them a message?
                </div>
                <div class="col-12 mb-2">
                  You have the option to notify the recipient of your message that they have a message stored on Remember Blue which will be delivered only in the event something were to happen to you. If you choose this option, your intended recipient will receive a message from Remember Blue notifying them that you have stored a message for them on our system. They will not be able to see the message until your passing on is confirmed.
                </div>
                <div class="col-12 mb-2">
                  The messages that are stored and delivered after your passing is confirmed will be delivered via email. Any attachments included will be included in the email.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 p-0">
          <div class="row m-0">
            <div class="col-12 p-0 my-3" id="deceased">
              <h4>Deceased</h4>
            </div>
            <div class="col-12">
              <h5 class="bold mb-2">Procedure after death</h5>
              <div class="row mx-0 my-3">
                <div class="col-12 bold mb-2">
                  What should I do if someone for whom I am a trustee passes away?
                </div>
                <div class="col-12">
                  If someone for whom you are a trustee passes away, the intention is that you or one of the other trustees initiates the verification process by notifying Remember Blue of your loved one’s passing. Login to your Remember Blue account and select the individual on your list of Trustors via the homepage>Trustor page. Click notify and the process of verification of your loved one will commence.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Help',
  props: ['scroll'],
  watch: {
    scroll () {
      this.$scrollTo('#' + this.scroll, 500, { offset: -75 })
    }
  }
}
</script>
